import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CaseNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-zinc-950/95 backdrop-blur-md border-b border-zinc-800/60 py-3'
          : 'bg-zinc-950/80 backdrop-blur-sm py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-lg">
            <i className="ri-rocket-2-fill text-white text-sm" />
          </div>
          <span className="text-white font-bold text-xl tracking-tight">
            boost<span className="text-orange-500">io</span>
          </span>
        </Link>

        {/* Breadcrumb */}
        <div className="hidden md:flex items-center gap-2 text-sm">
          <Link to="/" className="text-zinc-500 hover:text-zinc-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">
            Domov
          </Link>
          <i className="ri-arrow-right-s-line text-zinc-700" />
          <Link to="/" className="text-zinc-500 hover:text-zinc-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">
            Referencie
          </Link>
          <i className="ri-arrow-right-s-line text-zinc-700" />
          <span className="text-zinc-300 font-medium whitespace-nowrap">Case Study: SalenBike.sk</span>
        </div>

        {/* CTA */}
        <Link
          to="/#kontakt"
          className="bg-orange-500 hover:bg-orange-400 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Konzultácia zadarmo
        </Link>
      </div>
    </header>
  );
}
